import baseIsTypedArray from "./component-library365.mjs";
import baseUnary from "./component-library366.mjs";
import nodeUtil from "./component-library367.mjs";
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
const isTypedArray$1 = isTypedArray;
export {
  isTypedArray$1 as default
};
